import type { RaRegisterVersion } from './types.js';

/**
 * Vessel Risk Register ekranının saf yardımcıları (K4; ADR 0088): süzgeç ve sıra. Kural kararları
 * domain'dedir (`raAcknowledgementState`, `raAssignmentBasis`); burada yalnız görünüm.
 */

export const REGISTER_STATES = [
  'all',
  'pending',
  'acknowledged',
  'not_required',
  'review',
] as const;
export type RegisterState = (typeof REGISTER_STATES)[number];

export interface RegisterFilter {
  query: string;
  state: RegisterState;
}
export const EMPTY_REGISTER_FILTER: RegisterFilter = { query: '', state: 'all' };

const norm = (value: string | null | undefined) => (value ?? '').toLocaleLowerCase();

/**
 * Süzgeç ve sıra: onay bekleyen sürümler başta (register'da belirgin; R16), sonra koda göre.
 * "review": gözden geçirmesi yaklaşan ya da geçen.
 */
export function filterRegister(
  versions: readonly RaRegisterVersion[],
  filter: RegisterFilter,
): RaRegisterVersion[] {
  const q = norm(filter.query.trim());
  return versions
    .filter(
      (v) =>
        (filter.state === 'all' ||
          (filter.state === 'review'
            ? v.review === 'due' || v.review === 'overdue'
            : v.acknowledgement === filter.state)) &&
        (q === '' ||
          norm(v.code).includes(q) ||
          norm(v.title).includes(q) ||
          v.assessments.some((a) => norm(a.raNo).includes(q))),
    )
    .sort(
      (a, b) =>
        Number(b.acknowledgement === 'pending') - Number(a.acknowledgement === 'pending') ||
        a.code.localeCompare(b.code),
    );
}
